(function ($, Drupal, once) {
  'use strict';
  const behavior = 'deo_women_day.carousel';
  Drupal.behaviors[behavior] = {
    attach: function (context) {
      if (context === document) {
        DEOWomenDayCarousel(context);
      }
    }
  };

  const DEOWomenDayCarousel = (context) => {
    const $womendayCarouselBlock = $('.deo-womenday-carousel');
    if ($womendayCarouselBlock.length) {
      DEOCacheBuster();
      once('deoWomenDayCarouselInit', $womendayCarouselBlock).forEach((element) => {
        const $sheroesSwiperElement = $(element).find('.swiper.deo-carousel-items').get(0);
        if ($sheroesSwiperElement) {
          const $swiperContainer = $(element).find('.deo-carousel-items');
          const setPClasses = () => {
            $(element).find('.deo-carousel-item .deo-carousel-item-quote-text p').each(function () {
              const $text = $(this);
              $text.addClass('line-' + ($text.index()));
            });
          };
          setPClasses();
          const setSlideWidths = () => {
            const isNotMobile = () => window.innerWidth > 768;

            $(element).find('.deo-carousel-item').each(function () {
              const $slide = $(this);
              const $img = $slide.find('img');
              const $imgDiv = $slide.find('.deo-carousel-item-image');

              if ($img.length) {
                const imgWidth = $img[0].naturalWidth || $img.width();
                const imgHeight = $img.height();
                $slide.css('width', imgWidth + 'px');
                $imgDiv.css('height', imgHeight + 'px');
              }
            });
          };

          const initQuoteHover = () => {
            $(element).find('.deo-carousel-item-image').each(function () {
              const $imageContainer = $(this);

              // Mouse enter - add class
              $imageContainer.on('mouseenter', function () {
                $swiperContainer.addClass('quote-previewing');
              });

              // Mouse leave - remove class
              $imageContainer.on('mouseleave', function () {
                $swiperContainer.removeClass('quote-previewing');
              });
            });
          };
          initQuoteHover();

          // Initialize Swiper
          const sheroesCarousel = new Swiper($sheroesSwiperElement, {
            speed: 400,
            simulateTouch: true,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            lazy: true,
            preloadImages: false,
            centeredSlides: false,
            grabCursor: true,
            watchSlidesProgress: true,
            a11y: {
              enabled: true,
              slideRole: 'group',
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {
                freeMode: false,
              },
              768: {
                freeMode: true,
              }
            },
            on: {
              init: function () {
                setSlideWidths();
              }
            }
          });

          $(element).find('img').on('load', function () {
            setSlideWidths();
            sheroesCarousel.update();
          });

          $(window).on('resize', Drupal.debounce(() => {
            setSlideWidths();
            sheroesCarousel.update();
          }, 250));

        }
      });
    }
  };

  const DEOCacheBuster = () => {
    const url = new URL(window.location);
    url.searchParams.set('nocache', Date.now().toString());
    if (window.history.replaceState) {
      window.history.replaceState(null, null, url);
    }
  };

})(jQuery, Drupal, once);
